<template>
  <jc-card-layout
    class="order-steps"
    collapse
    title="流程轨迹"
    header-background-color="#59DAD9"
    header-color="#fff"
    header-border-color="#59DAD9"
  >
    <div class="order-steps-container">
      <div class="steps-item">
        <el-steps :active="active" align-center>
          <el-step
            v-for="item in steps"
            :title="item.name"
            :description="item.date"
            :name="item.number"
            :key="item.number"
          ></el-step>
        </el-steps>
      </div>
      <div class="order-oper">
        <div class="title" v-if="records && records.length">操作记录</div>
        <div class="oper-container">
          <div
            class="order-oper-item"
            v-for="(item, index) in records"
            :key="index"
          >
            <div>
              <span class="user">操作者：{{ item.operationUser }}</span
              ><span>操作时间：{{ item.operationDate }}</span>
            </div>
            <div>操作：{{ item.operationAction }}</div>
          </div>
        </div>
      </div>
    </div>
  </jc-card-layout>
</template>

<script>
// 流程轨迹
export default {
  name: 'workflow',
  props: {
    steps: {
      type: Object,
      default() {
        return {}
      }
    },
    records: {
      type: Array,
      default() {
        return []
      }
    },
    active: {}
  }
}
</script>

<style lang="scss">
.order-steps {
  margin-top: 12px;
  .order-steps-container {
    .steps-item {
      padding: 40px 0;
    }
    .order-oper {
      padding: 0px 18px;
      .title {
        color: #606060;
        padding: 10px 0;
        font-size: 14px;
        border-bottom: 1px solid #d7d7d7;
      }
      .oper-container {
        margin: 10px 0 0;
        .order-oper-item {
          width: 400px;
          padding-left: 12px;
          min-height: 56px;
          display: flex;
          justify-content: center;
          flex-direction: column;
          border-radius: 4px;
          font-size: 12px;
          color: #606060;
          border: 1px solid rgba(151, 151, 151, 1);
          margin-bottom: 12px;
          white-space: normal;
          word-break: break-all;
          &:last-child {
            margin-bottom: 0;
          }
          .user {
            margin-right: 30px;
          }
        }
      }
    }
  }
  & .el-step.is-center .el-step__line {
    left: 60%;
    right: -40%;
  }
  .el-step__icon-inner {
    font-weight: 400;
  }
  .el-step__head.is-finish {
    color: #fff;
    border-color: #409bff;
  }
  .el-step__icon {
    width: 30px;
    height: 30px;
  }
  .is-finish {
    .el-step__icon {
      background-color: #409bff;
    }
    &.el-step__description {
      color: #606060;
    }
  }
  .el-step__title {
    font-size: 14px;
    line-height: 38px;
  }
  .el-step.is-horizontal .el-step__line {
    height: 2px;
    top: 15px;
  }
  .is-process {
    color: #606060;
    font-weight: 500;
    .el-step__icon {
      border: 1px solid #606060;
    }
  }
  .el-step__icon {
    border-width: 1px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/workflow.vue